const FOCUSABLE_SELECTOR = [
  'a[href]',
  'area[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'iframe',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
  '[tabindex]',
].join(',');

/** Returns the tabbable descendants of `container`, in DOM order. */
export function getTabbable(container: HTMLElement): HTMLElement[] {
  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter((el) => {
    if (el.tabIndex < 0) return false;
    if (el.closest('[inert],[hidden]')) return false;
    // Radio groups: only the checked (or first) radio is in the tab sequence.
    if (el instanceof HTMLInputElement && el.type === 'radio' && el.name && !el.checked) {
      const group = Array.from(
        container.querySelectorAll<HTMLInputElement>('input[type="radio"]'),
      ).filter((r) => r.name === el.name);
      const anyChecked = group.some((r) => r.checked);
      if (anyChecked || group[0] !== el) return false;
    }
    return true;
  });
}

export function focusElement(el: HTMLElement | null | undefined): void {
  if (!el) return;
  try {
    el.focus({ preventScroll: false });
  } catch {
    el.focus();
  }
}

export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}
